export default "__VITE_ASSET__59aa8070__"